module.exports = __webpack_public_path__ + "static/paragraph-2-1067004a1a4abde3e1a47e0881e5a6d2.svg";